import { useLazyQuery, useQuery } from '@apollo/client'
import { Product, Query, ReviewQueryResult } from '@danone-global/ct/interfaces'
import { useEffect } from 'react'

import { GET_REVIEW_PRODUCT_INFO, GET_REVIEWS_QUERY } from './reviews.graphql'

export interface UseProductReviews {
  reviews: ReviewQueryResult
  product: Product
  refetch: (variables?: any) => void
  loading: boolean
}

export const useProductReviews = (
  sku: string,
  limit: number,
  sorting: string,
): UseProductReviews => {
  const { data } = useQuery<Query>(GET_REVIEW_PRODUCT_INFO, {
    variables: {
      sku: `${sku}`,
    },
  })

  const [getReviews, { data: reviewsData, refetch, fetchMore, loading }] =
    useLazyQuery<Query>(GET_REVIEWS_QUERY)

  useEffect(() => {
    if (data?.product?.id && data?.state?.id) {
      getReviews({
        variables: {
          where: `target(typeId = "product" and id = "${data.product.id}") and state(id="${data.state.id}")`,
          sorting,
          limit,
        },
        fetchPolicy: 'network-only'
      })
    }
  }, [data?.product, sorting])

  useEffect(() => {
    if (limit && reviewsData?.reviews?.count < limit) {
      fetchMore({
        variables: {
          limit,
        },
      })
    }
  }, [limit])

  return {
    reviews: reviewsData?.reviews,
    product: data?.product,
    refetch,
    loading,
  }
}
